"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1646))
 * @trackcomponent
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const MagicWand = createSVGIcon(
  <path
    d="m21.566 3.305-1.444 4.25a.69.69 0 0 0 .101.632l2.682 3.6a.685.685 0 0 1-.56 1.098l-4.489-.055a.69.69 0 0 0-.57.291l-2.593 3.664a.685.685 0 0 1-1.217-.194l-1.33-4.286a.69.69 0 0 0-.453-.452l-4.286-1.33a.686.686 0 0 1-.193-1.218l3.668-2.592a.69.69 0 0 0 .292-.569l-.055-4.49a.687.687 0 0 1 1.097-.559l3.597 2.676a.69.69 0 0 0 .632.102l4.25-1.444a.686.686 0 0 1 .87.876ZM11.976 12.024.956 23.044"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "MagicWand",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
